let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f7DAk")).then(() => parcelRequire('21SRQ'));